// @flow

import * as React from 'react';
import '../App.css';
import 'antd/dist/antd.css';
import {BugOutlined, GithubOutlined, TeamOutlined, UserOutlined} from '@ant-design/icons';
import {Layout, Menu} from 'antd';
import {withRouter} from 'react-router-dom';
import type {History} from 'react-router';

const {SubMenu} = Menu;
const {Sider} = Layout;

type Props = {
  history: History
};

function MenuBar({history}: Props): React.Node {
  return (
    <Sider width={200} className="site-layout-background">
      <Menu
        style={{height: '100%', borderRight: 0}}
      >
        <SubMenu
          onTitleClick={() => {
            history.push('/heroes');
          }}
          key="sub1"
          icon={<UserOutlined/>}
          title="Heroes">
        </SubMenu>
        <SubMenu
          onTitleClick={() => {
            history.push(
              '/teams?' + (localStorage.getItem(
              'team_optimizer_options',
              ) ?? ''),
            );
          }}
          key="sub2"
          icon={<TeamOutlined/>}
          title="Team Optimizer">
        </SubMenu>
        <SubMenu
          onTitleClick={() => {
            window.open('https://www.reddit.com/r/GuardianTales/comments/ial3rf/team_optimizer/');
          }}
          key="sub3"
          icon={<BugOutlined/>}
          title="Report Bugs">
        </SubMenu>
        <SubMenu
          onTitleClick={() => {
            window.open('https://github.com/clh161/guardian-tales/');
          }}
          key="sub4"
          icon={<GithubOutlined/>}
          title="Report Bugs">
        </SubMenu>
      </Menu>
    </Sider>
  );
}

export default withRouter(MenuBar);
